import React, { useEffect, useState } from "react";
export default function TopScrollingText() {
    const text = "Minimum 2 pieces (You can mix any Pattern / Models) for an order, 360° opening video must for any sort of complaint, Customer care : 9360990836.";
    const [displayText, setDisplayText] = useState("");
    const [index, setIndex] = useState(0);
    useEffect(() => {
        let timeout;
        if (index < text.length) {
            timeout = setTimeout(() => {
                setDisplayText((prev) => prev + text[index]);
                setIndex(index + 1);
            }, 40);
        } else {
            timeout = setTimeout(() => {
                setDisplayText("");
                setIndex(0);
            }, 4000);
        }
        return () => clearTimeout(timeout);
    }, [index, text]);
    return (
        <div className="typing-wrapper">
            <span className="typing-text">{displayText}</span>
        </div>
    );
}